import React from 'react';
import styled, { keyframes } from 'styled-components';
import { rgba, timingFunctions } from 'polished';
import ClickOutside from 'react-click-outside';

import { fadeInScale } from 'styles/animation';
import { white, brandColors } from 'styles/colors';
import { pageToolbarHeight } from 'styles/spacings';

export const PADDING = '30px';

const fillInBackground = keyframes`
	from { background-color: ${rgba('#fff', 0)}; }
	to { background-color: ${rgba('#fff', 0.8)}; }
`;

export const Wrapper = styled.div`
	z-index: ${props => props.zIndex || (props.isOverlay ? '1' : '0')};
	position: ${props => (props.isOverlay ? 'fixed' : 'absolute')};
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: ${rgba('#fff', 0.8)};
	display: flex;
	justify-content: center;
	align-items: center;
	animation: 333ms ${fillInBackground} ease-out both;
`;

export const Popup = styled(props => <ClickOutside {...props} />)`
	margin: ${PADDING};
	width: ${props => props.popupwidth || '525px'};
	background-color: ${white};
	box-shadow: 0 2px 24px 0 ${rgba('#000', 0.09)};
	animation: 666ms ${fadeInScale} ${timingFunctions('easeOutExpo')} both;
`;

export const Header = styled.header`
	height: ${pageToolbarHeight};
	padding: 0 ${PADDING};
	text-transform: uppercase;
	font-size: 13px;
	font-weight: bold;
	letter-spacing: 0.8px;
	border-bottom: 1px solid ${rgba('#000', 0.09)};
	display: flex;
	align-items: center;
`;

export const Content = styled.div`
	padding: ${PADDING};
	position: relative;
`;

export const Footer = styled.footer`
	height: ${pageToolbarHeight};
	display: flex;
	justify-content: ${({ hasCancel, hasSubmit }) =>
		hasCancel && hasSubmit ? 'space-between' : 'flex-end'};
	background-color: #f8f8f8;
`;

export const Button = styled(({ children, ...props }) => (
	<button {...props}>
		<ButtonText>{children}</ButtonText>
	</button>
))`
	outline: 0 none;
	border: 0 none;
	color: inherit;
	font: inherit;
	padding: 0 ${PADDING};

	&[type='submit'] {
		color: ${brandColors.green};
	}

	&:not(:disabled) {
		cursor: pointer;
	}
`;

export const ButtonText = styled.span`
	text-transform: uppercase;
	font-size: 12px;
	font-weight: bold;
	border-bottom: 2px solid transparent;
	transition: border 200ms ease-in-out;
	letter-spacing: 0.8px;

	${Button}:disabled & {
		opacity: 0.4;
	}

	${Button}:not(:disabled):hover &,
	${Button}:not(:disabled):focus & {
		border-color: currentColor;
	}
`;
